import { Languages } from "src/common/descriptions/types";

export interface SysSettings {
    LANGUAGE?: Languages
}

export enum SettingsKeys {
    LANGUAGE = 'LANGUAGE',
}